import type { Runtime } from './host';

export type Capability =
  | 'telegramBackButton'
  | 'swipeBackGesture'
  | 'closingConfirmation'
  | 'themeChrome'
  | 'fullscreenExpand'
  | 'safeAreaInsets'

  | 'haptics'
  | 'starsPayment'
  | 'nativeShare'
  | 'preparedMessage'
  | 'tmaConfirmPopup'
  | 'tmaAlertPopup'
  | 'inlineLinkOpen'
  | 'telegramLinkOpen'
  | 'closeApp'

  | 'initDataAuth'
  | 'loginWidgetAuth'
  | 'steamOpenIdAuth'
  | 'logoutAction'

  | 'desktopLayout'
  | 'desktopHeader'
  | 'mobileTabBar'

  | 'channelSubscriptionTask'
  | 'channelBoostTask'
  | 'profileBioTask'

  | 'recruiterTmaOnly'
  | 'supportChatWidget'
  | 'profileShare'
  | 'referralShare'
  | 'matchStreamLink'

  | 'publicCaseListView'
  | 'publicCaseDetailView'
  | 'publicProfileView'
  | 'publicItemView'
  | 'publicItemInCaseView';

export const CAPABILITIES: Record<Runtime, ReadonlySet<Capability>> = {
  tma: new Set<Capability>([
    'telegramBackButton',
    'swipeBackGesture',
    'closingConfirmation',
    'themeChrome',
    'fullscreenExpand',
    'safeAreaInsets',

    'haptics',
    'starsPayment',
    'nativeShare',
    'preparedMessage',
    'tmaConfirmPopup',
    'tmaAlertPopup',
    'inlineLinkOpen',
    'telegramLinkOpen',
    'closeApp',

    'initDataAuth',

    'desktopLayout',
    'desktopHeader',
    'mobileTabBar',

    'channelSubscriptionTask',
    'channelBoostTask',
    'profileBioTask',

    'recruiterTmaOnly',
    'profileShare',
    'referralShare',
    'matchStreamLink',
  ]),

  web: new Set<Capability>([
    'loginWidgetAuth',
    'steamOpenIdAuth',
    'logoutAction',

    'desktopLayout',
    'desktopHeader',
    'mobileTabBar',

    'supportChatWidget',

    'profileShare',
    'referralShare',
    'matchStreamLink',

    'publicCaseListView',
    'publicCaseDetailView',
    'publicProfileView',
    'publicItemView',
    'publicItemInCaseView',
  ]),
};
